import axios from "axios";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { rsToken, rsUserData, rsProgress } from "./RecoilStates";
import { useRecoilState } from "recoil";

export function UseCustomAxios() {
  const { enqueueSnackbar } = useSnackbar();
  const [msToken, setMsToken] = useRecoilState(rsToken);
  const [msUserData, setMsUserData] = useRecoilState(rsUserData);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();

  var MyAxios = axios.create({
    baseURL: window.ENV.url,
    headers: {
      token: msToken,
    },
  });

  MyAxios.interceptors.response.use(
    (res) => {
      // console.log(res);
      setTimeout(() => {
        setProgress(false);
      }, 300);
      if (res.data.state == 200) {
        return res;
      } else if (res.data.state == 403 || res.data.state == 404) {
        setMsToken(undefined);
        setMsUserData(undefined);
        localStorage.removeItem("ControllPanellUserData");
        localStorage.removeItem("ControllPanellToken");
        navigate("/login");
        enqueueSnackbar("لطفا مجددا لاگین نمایید", {
          variant: "error",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
      } else if (res.data.state == 2) {
        navigate("/notPermission");
      } else {
        console.log(res);
        enqueueSnackbar(res.data.message, {
          variant: "error",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
      }
    },
    (e) => {
      setProgress(false);
      console.log(e);
    }
  );

  return MyAxios;
}
